export default __webpack_public_path__ + "static/media/RDJ_Logo.1103f031.png";